import { makeAutoObservable } from "mobx";

export class StreamingChatStore {
  private _streamingText = "";
  private _streamingThoughts = "";
  private _currentAction = "";
  private _stopCallback: (() => void | Promise<void>) | null = null;

  constructor() {
    makeAutoObservable<StreamingChatStore, "_stopCallback">(this, {
      _stopCallback: false,
    });
  }

  public get streamingText(): string {
    return this._streamingText;
  }

  public get streamingThoughts(): string {
    return this._streamingThoughts;
  }

  public get currentAction(): string {
    return this._currentAction;
  }

  public startStreaming(): void {
    this._streamingText = "";
    this._streamingThoughts = "";
    this._currentAction = "";
    this._stopCallback = null;
  }

  public registerStopCallback(callback: () => void | Promise<void>): void {
    this._stopCallback = callback;
  }

  public appendText(chunk: string): void {
    this._streamingText += chunk;
  }

  public appendThought(chunk: string): void {
    this._streamingThoughts += chunk;
  }

  public setAction(action: string): void {
    this._currentAction = action;
  }

  public completeStreaming(): void {
    this.reset();
  }

  public stopStreaming(): void {
    if (!this._stopCallback) {
      return;
    }

    const stopCallback = this._stopCallback;
    this._stopCallback = null;
    void Promise.resolve(stopCallback()).catch(error => {
      console.error("Failed to cancel chat streaming", error);
    });
  }

  public reset(): void {
    this._streamingText = "";
    this._streamingThoughts = "";
    this._currentAction = "";
    this._stopCallback = null;
  }
}
